import gmt from './gmt';

export default {
  mixins: [gmt],
  methods: {
    keyValues(profile) {
      return [
        {
          label: 'Name',
          field: 'name',
          value: profile.name,
          link: {
            name: 'profiles.index.detail',
            params: { id: profile.id },
          },
        },
        {
          label: 'Description',
          field: 'description',
          value: profile.description,
        },
        {
          label: 'Analytics',
          field: 'analytics',
          value: profile.analytics.length,
          link: {
            name: 'profiles.index.analytics',
            params: { id: profile.id },
          },
          centered: true,
        },
        {
          label: 'Auto Update',
          field: 'autoUpdate',
          value: ((profile.autoUpdate === true) ? 'Yes' : 'No'),
          centered: true,
        },
        {
          label: 'Sync Interval',
          field: 'infoSyncInterval',
          value: this.$options.filters.secondsToString(profile.infoSync.infoSyncInterval),
        },
        {
          label: 'Insights',
          field: 'insightsSyncInterval',
          value: ((profile.infoSync.attrs.includes('insights') ? 'Enabled' : 'Disabled')),
        },
        {
          label: 'Actions Config',
          field: 'actionConfigsId',
          value: profile.actionConfigs.name,
          link: {
            name: 'actions.index.detail',
            params: { id: profile.actionConfigs.id },
          },
        },
        {
          label: 'Created',
          field: 'created',
          value: this.$options.filters.formatEpochDate(profile.created, this.gmt),
        },
        {
          label: 'Modified',
          field: 'updated',
          value: this.$options.filters.formatEpochDate(profile.updated, this.gmt),
        },
        {
          label: 'Hash',
          field: 'hash',
          value: profile.hash,
        },
      ];
    },
  },
};
